import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { changePassword, patchProfile, userInitials } from '../api/auth';
import { UserIdentityFields } from '../components/UserIdentityFields';
import { ASSETS } from '../config/assets';
function profileHeaderName(firstName, lastName, jobTitle) {
    const name = [firstName.trim(), lastName.trim()].filter(Boolean).join(' ');
    const job = jobTitle.trim();
    if (name && job)
        return `${name}, ${job}`;
    return name || job || '—';
}
export function ProfilePage({ plan }) {
    const { state, handlers, userRole } = plan;
    const passwordUnset = state.passwordUnset;
    const [firstName, setFirstName] = useState(state.userFirstName);
    const [lastName, setLastName] = useState(state.userLastName);
    const [jobTitle, setJobTitle] = useState(state.userJobTitle);
    const [profileSaving, setProfileSaving] = useState(false);
    const [profileError, setProfileError] = useState('');
    const [pwOpen, setPwOpen] = useState(false);
    const [oldPw, setOldPw] = useState('');
    const [newPw, setNewPw] = useState('');
    const [newPw2, setNewPw2] = useState('');
    const [pwError, setPwError] = useState('');
    const [pwSuccess, setPwSuccess] = useState(false);
    const [pwSaving, setPwSaving] = useState(false);
    const initials = userInitials(firstName, lastName);
    const headerName = profileHeaderName(firstName, lastName, jobTitle);
    const handleSaveProfile = async (e) => {
        e.preventDefault();
        if (profileSaving)
            return;
        setProfileError('');
        setProfileSaving(true);
        try {
            const user = await patchProfile({
                firstName: firstName.trim(),
                lastName: lastName.trim(),
                jobTitle: jobTitle.trim(),
            });
            handlers.updateUserProfile({
                firstName: user.firstName,
                lastName: user.lastName,
                jobTitle: user.jobTitle,
                fullName: user.fullName,
            });
            setFirstName(user.firstName ?? firstName.trim());
            setLastName(user.lastName ?? lastName.trim());
            setJobTitle(user.jobTitle ?? jobTitle.trim());
        }
        catch (err) {
            setProfileError(err instanceof Error ? err.message : 'Не удалось сохранить профиль');
        }
        finally {
            setProfileSaving(false);
        }
    };
    const handleChangePassword = async (e) => {
        e.preventDefault();
        if (pwSaving)
            return;
        setPwError('');
        setPwSuccess(false);
        if (!passwordUnset && !oldPw) {
            setPwError('Введите текущий пароль');
            return;
        }
        if (newPw.length < 8) {
            setPwError('Новый пароль — минимум 8 символов');
            return;
        }
        if (newPw !== newPw2) {
            setPwError('Пароли не совпадают');
            return;
        }
        setPwSaving(true);
        try {
            await changePassword(oldPw, newPw);
            setPwSuccess(true);
            handlers.setPasswordUnset(false);
            setOldPw('');
            setNewPw('');
            setNewPw2('');
        }
        catch (err) {
            setPwError(err instanceof Error ? err.message : 'Не удалось изменить пароль');
        }
        finally {
            setPwSaving(false);
        }
    };
    return (_jsxs("div", { style: { minHeight: '100vh', background: '#F8FAFC', display: 'flex', flexDirection: 'column' }, children: [_jsxs("div", { style: {
                    height: 50,
                    flex: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    padding: '0 14px',
                    background: '#FFFFFF',
                    borderBottom: '1px solid #E2E8F0',
                }, children: [_jsxs("button", { type: "button", onClick: handlers.goHome, title: "\u041D\u0430 \u0433\u043B\u0430\u0432\u043D\u044B\u0439 \u044D\u043A\u0440\u0430\u043D", className: "kp-home-link", style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            textDecoration: 'none',
                            color: 'inherit',
                            border: 'none',
                            borderRadius: 8,
                            padding: '2px 6px',
                            marginLeft: -6,
                            background: 'none',
                            cursor: 'pointer',
                        }, children: [_jsx("img", { src: ASSETS.logo, alt: "", style: { width: 28, height: 28 } }), _jsx("span", { style: { fontSize: 14.5, fontWeight: 700, letterSpacing: '-0.01em' }, children: "\u041A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u043B\u0430\u043D" })] }), _jsx("div", { style: { width: 1, height: 20, background: '#E2E8F0' } }), _jsx("div", { style: { fontSize: 13.5, color: '#475569' }, children: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C" }), _jsx("button", { type: "button", onClick: handlers.closeProfile, className: "kp-back-btn", style: {
                            marginLeft: 'auto',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            height: 32,
                            padding: '0 12px',
                            border: '1px solid #CBD5E1',
                            borderRadius: 8,
                            background: '#FFFFFF',
                            fontSize: 12.5,
                            fontWeight: 600,
                            color: '#334155',
                            cursor: 'pointer',
                        }, children: "\u2190 \u041A \u043F\u043B\u0430\u043D\u0443" })] }), _jsx("div", { style: { flex: 1, display: 'flex', justifyContent: 'center', padding: '40px 24px' }, children: _jsxs("div", { style: { width: 420, display: 'flex', flexDirection: 'column', gap: 16 }, children: [_jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 12 }, children: [_jsx("span", { style: {
                                        width: 44,
                                        height: 44,
                                        borderRadius: '50%',
                                        background: '#DBEAFE',
                                        color: '#1D4ED8',
                                        fontSize: 15,
                                        fontWeight: 700,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }, children: initials }), _jsxs("div", { style: { display: 'flex', flexDirection: 'column', gap: 2 }, children: [_jsx("span", { style: { fontSize: 15, fontWeight: 700 }, children: headerName }), _jsx("span", { style: { fontSize: 12.5, color: '#64748B' }, children: state.userEmail })] })] }), _jsxs("form", { onSubmit: handleSaveProfile, style: {
                                background: '#FFFFFF',
                                border: '1px solid #E2E8F0',
                                borderRadius: 12,
                                padding: 20,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 14,
                            }, children: [_jsx("div", { style: { fontSize: 14, fontWeight: 700 }, children: "\u041B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435" }), _jsx(UserIdentityFields, { email: state.userEmail, firstName: firstName, lastName: lastName, jobTitle: jobTitle, accessLevel: userRole, onFirstNameChange: setFirstName, onLastNameChange: setLastName, onJobTitleChange: setJobTitle }), profileError ? (_jsx("div", { style: {
                                        fontSize: 12,
                                        color: '#B91C1C',
                                        background: '#FEF2F2',
                                        border: '1px solid #FECACA',
                                        borderRadius: 8,
                                        padding: '8px 10px',
                                    }, children: profileError })) : null, _jsx("button", { type: "submit", disabled: profileSaving, className: "kp-login-btn", style: {
                                        height: 38,
                                        border: 'none',
                                        borderRadius: 8,
                                        background: '#2563EB',
                                        color: '#FFFFFF',
                                        fontSize: 13,
                                        fontWeight: 600,
                                        cursor: 'pointer',
                                        opacity: profileSaving ? 0.7 : 1,
                                    }, children: profileSaving ? 'Сохранение…' : 'Сохранить' })] }), _jsxs("div", { style: {
                                background: '#FFFFFF',
                                border: '1px solid #E2E8F0',
                                borderRadius: 12,
                                padding: 20,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 14,
                            }, children: [_jsxs("button", { type: "button", onClick: () => setPwOpen((v) => !v), style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8,
                                        border: 'none',
                                        background: 'none',
                                        padding: 0,
                                        fontSize: 14,
                                        fontWeight: 700,
                                        color: '#0F172A',
                                        cursor: 'pointer',
                                        textAlign: 'left',
                                    }, children: [_jsx("span", { children: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C" }), _jsx("span", { style: { marginLeft: 'auto', fontSize: 10, color: '#94A3B8' }, children: pwOpen ? '▾' : '▸' })] }), pwOpen ? (_jsxs("form", { onSubmit: handleChangePassword, style: { display: 'flex', flexDirection: 'column', gap: 14 }, children: [_jsxs("label", { style: {
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 5,
                                                fontSize: 11.5,
                                                fontWeight: 600,
                                                color: '#334155',
                                            }, children: [passwordUnset ? 'Задайте пароль (старый не нужен)' : 'Старый пароль', _jsx("input", { type: "password", value: oldPw, onChange: (e) => setOldPw(e.target.value), autoComplete: "current-password", placeholder: passwordUnset ? 'оставьте пустым' : undefined, className: "kp-input", style: {
                                                        height: 36,
                                                        border: '1px solid #CBD5E1',
                                                        borderRadius: 8,
                                                        padding: '0 10px',
                                                        fontSize: 13,
                                                        outline: 'none',
                                                    } })] }), _jsxs("label", { style: {
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 5,
                                                fontSize: 11.5,
                                                fontWeight: 600,
                                                color: '#334155',
                                            }, children: ["\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C", _jsx("input", { type: "password", value: newPw, onChange: (e) => setNewPw(e.target.value), autoComplete: "new-password", className: "kp-input", style: {
                                                        height: 36,
                                                        border: '1px solid #CBD5E1',
                                                        borderRadius: 8,
                                                        padding: '0 10px',
                                                        fontSize: 13,
                                                        outline: 'none',
                                                    } }), _jsx("span", { style: { fontSize: 10.5, fontWeight: 400, color: '#94A3B8' }, children: "\u043C\u0438\u043D\u0438\u043C\u0443\u043C 8 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432" })] }), _jsxs("label", { style: {
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 5,
                                                fontSize: 11.5,
                                                fontWeight: 600,
                                                color: '#334155',
                                            }, children: ["\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C \u0435\u0449\u0451 \u0440\u0430\u0437", _jsx("input", { type: "password", value: newPw2, onChange: (e) => setNewPw2(e.target.value), autoComplete: "new-password", className: "kp-input", style: {
                                                        height: 36,
                                                        border: '1px solid #CBD5E1',
                                                        borderRadius: 8,
                                                        padding: '0 10px',
                                                        fontSize: 13,
                                                        outline: 'none',
                                                    } })] }), pwError ? (_jsx("div", { style: {
                                                fontSize: 12,
                                                color: '#B91C1C',
                                                background: '#FEF2F2',
                                                border: '1px solid #FECACA',
                                                borderRadius: 8,
                                                padding: '8px 10px',
                                            }, children: pwError })) : null, pwSuccess ? (_jsx("div", { style: {
                                                fontSize: 12,
                                                color: '#166534',
                                                background: '#F0FDF4',
                                                border: '1px solid #BBF7D0',
                                                borderRadius: 8,
                                                padding: '8px 10px',
                                            }, children: "\u041F\u0430\u0440\u043E\u043B\u044C \u0438\u0437\u043C\u0435\u043D\u0451\u043D" })) : null, _jsx("button", { type: "submit", disabled: pwSaving, className: "kp-login-btn", style: {
                                                height: 38,
                                                border: 'none',
                                                borderRadius: 8,
                                                background: '#2563EB',
                                                color: '#FFFFFF',
                                                fontSize: 13,
                                                fontWeight: 600,
                                                cursor: 'pointer',
                                                opacity: pwSaving ? 0.7 : 1,
                                            }, children: pwSaving ? 'Сохранение…' : 'Изменить пароль' })] })) : null] })] }) })] }));
}
